
// @ts-nocheck
import type { PropType } from 'vue'
import { defineComponent } from 'vue'
import { debounce } from 'lodash'
import PaginationComp from '~/components/new/blocks/Pagination/PaginationComp.vue'
import BaseInput from '~/components/new/ui/inputs/BaseInput.vue'
import FilterIcon from '~/components/icons/Filter.vue'
import Sort from '~/components/icons/Sort.vue'
import Search from '~/components/icons/Search.vue'
import BaseButton from '~/components/new/ui/BaseButton.vue'
import type { CatalogKeys, FilterCheckbox, FilterObj, FilterObjCheckbox } from '~/types/Catalog'
import BaseSelect from '~/components/new/ui/inputs/BaseSelect.vue'
import Cross from '~/components/icons/Cross.vue'
import { useWindowHandlers } from '~/store/window'
import { getLabel, isDefaultValue } from '~/util'
import { groupItemsByColumn } from '~/util/catalogFunctions'
const queryHandler = function (queryParams: Record<string, number | string | Array<string | number> | undefined>, thisObj = this) {
  if (queryParams?.sort_order) {
    queryParams.sort_field = 'price'
  } else {
    queryParams.sort_field = undefined
  }
  const query = {
    ...thisObj.$route.query,
    ...queryParams
  }

  thisObj.$router.replace({
    query
  })
}

export default defineComponent({
  components: {
    PaginationComp,
    BaseInput,
    FilterIcon,
    Search,
    BaseButton,
    BaseSelect,
    Sort,
    Cross,
    FiltersModal: () => import('~/components/new/modals/CatalogFilters/CatalogFilters.vue')
  },

  props: {
    // eslint-disable-next-line vue/require-default-prop
    checkboxes: {
      type: Object as PropType<FilterObjCheckbox>,
      default: () => {},
      required: false
    },
    currentPage: {
      type: Number,
      required: true
    },
    lastPage: {
      type: Number,
      required: true
    },
    firstPage: {
      type: Number,
      required: true
    },
    // eslint-disable-next-line vue/require-default-prop
    maxPrice: {
      type: Number,
      required: false
    },
    isPaintings: {
      type: Boolean,
      default: false
    },
    cities: {
      type: Array as PropType<Array<{ title: string, value: string }>>,
      default: () => []
    },
    showFilters: {
      type: Boolean,
      default: true
    },
    preGroupedItems: {
      type: Boolean,
      default: false
    },
    showSort: {
      type: Boolean,
      default: true
    },
    showSearch: {
      type: Boolean,
      default: true
    },
    emptyMessage: {
      type: String,
      default: ''
    },
    items: {
      type: Array as PropType<Array<T>>,
      default: () => []
    },
    itemsPerPage: {
      type: Number,
      required: true
    },
    searchQueryDelay: {
      type: Number,
      default: 500
    },
    autoResizeSearch: {
      type: Boolean,
      default: false
    },
    autoResizeSearchMaxWidth: {
      type: Number,
      default: 0
    },
    autoScroll: {
      type: Boolean,
      default: true
    },
    // eslint-disable-next-line vue/require-default-prop
    queryScrollKeys: {
      type: Array as PropType<string[]>,
      required: false
    },
    handlePageQueryErrors: {
      type: Boolean,
      default: true
    }
  },

  emits: {
    'apply-filters' (payload: FilterObj) {
      return !!payload
    }
  },

  data () {
    const sortVariants = [
      { title: 'По новизне', value: '' },
      { title: 'По убыванию цены', value: 'desc' },
      { title: 'По возрастанию цены', value: 'asc' }
    ]

    const debouncedQueryHandler = debounce(queryHandler, this.searchQueryDelay)

    return {
      filtersModal: false,
      sortVariants,
      pageRange: 3,
      hrefBody: process.env.API_ENDPOINT + this.$route.path + '/',
      debouncedQueryHandler,

      searchQuery: this.$route.query.search || '',
      searchInputElement: null,
      sortQuery: sortVariants.find(variant => variant.value === this.$route.query.sort_order) || sortVariants[0],

      localCheckboxes: this.checkboxes || {}
    }
  },
  computed: {
    query () {
      return this.$route.query
    },
    activeFilters () {
      const cityFilters = this.$route.query.location

        ? [this.cities.find(cityEl => cityEl.value === this.$route.query.location)]
        : [{ value: '' }]

      return {
        in_sale: {

          filters: [{ value: this.$route.query.in_sale || '' }]
        },
        location: {
          filters: cityFilters
        },

        // paintings only

        ...(this.isPaintings
          ? {
              price_from: {

                filters: [{ value: +this.$route.query.price_from || 0 }]
              },
              price_to: {

                filters: [{ value: +this.$route.query.price_to || 1000000 }]
              },
              height_from: {

                filters: [{ value: +this.$route.query.height_from || 0 }]
              },
              height_to: {

                filters: [{ value: +this.$route.query.height_to || 2000 }]
              },
              width_from: {

                filters: [{ value: +this.$route.query.width_from || 0 }]
              },
              width_to: {

                filters: [{ value: +this.$route.query.width_to || 2000 }]
              },
              year_from: {

                filters: [{ value: +this.$route.query.year_from || 1900 }]
              },
              year_to: {

                filters: [{ value: +this.$route.query.year_to || new Date().getFullYear() }]
              }
            }
          : {})
      }
    },
    defaultFilters () {
      const cityFilters = [{ value: '' }]

      return {
        in_sale: {

          filters: [{ value: '' }]
        },
        location: {
          filters: cityFilters
        },

        // paintings only

        ...(this.isPaintings
          ? {
              price_from: {

                filters: [{ value: 0 }]
              },
              price_to: {

                filters: [{ value: 1000000 }]
              },
              height_from: {

                filters: [{ value: 0 }]
              },
              height_to: {

                filters: [{ value: 2000 }]
              },
              width_from: {

                filters: [{ value: 0 }]
              },
              width_to: {

                filters: [{ value: 2000 }]
              },
              year_from: {

                filters: [{ value: 1900 }]
              },
              year_to: {

                filters: [{ value: new Date().getFullYear() }]
              }
            }
          : {})
      }
    },
    activeCheckboxes () {
      const result = {}

      if (this.$route.query.having_tags) {
        for (const key in this.localCheckboxes) {
          const filteredArr = this.localCheckboxes[key].filter(checkbox => checkbox.checked)

          if (filteredArr.length > 0) { result[key] = { ...filteredArr } }
        }
      }

      return result
    },
    displayingFilters () {
      const result = {}

      for (const key in this.activeFilters) {
        if (!this.isDefaultValue(key as CatalogKeys, this.activeFilters[key].filters[0].value, this.maxPrice)) { result[key] = this.activeFilters[key] }
      }
      return result
    },
    hasDisplayingFilters () {
      return Object.keys(this.displayingFilters).length > 0 || Object.keys(this.activeCheckboxes).length > 0
    },
    catalogItems () {
      if (this.preGroupedItems) { return this.items }
      if (this.itemsPerPage < 1) { return [] }
      return groupItemsByColumn(this.items, this.itemsPerPage / 4)
    },
    currentPageComp () {
      if (this.currentPage > this.lastPage) {
        if (!this.handlePageQueryErrors) { return this.lastPage }
        this.queryHandler({ page: this.lastPage }, this)
      }

      if (this.currentPage < this.firstPage) {
        if (!this.handlePageQueryErrors) { return this.firstPage }
        this.queryHandler({ page: this.firstPage }, this)
      }

      return this.currentPage
    }
  },
  watch: {
    async catalogItems () {
      if (!this.$refs.catalogEl || !this.autoScroll || this.queryScrollKeys) { return }

      await this.$nextTick()
      this.$refs.catalogEl.scrollIntoView({ start: 'block', behavior: 'smooth' })
      this.$refs.catalogEl.focus()
    },
    autoResizeSearch: {
      handler (state) {
        if (!this.$refs.selectEl) { return 11 }
        if (state) { this.addAutoResize() } else { this.removeAutoResize() }
      }

    }
  },
  async mounted () {
    if (this.autoResizeSearch && this.$refs.selectEl) {
      this.addAutoResize()
      this.searchAutoresizeHandler()
    }

    if (this.queryScrollKeys) {
      this.$watch('query', async (value, old) => {
        for (const key of this.queryScrollKeys) {
          if (value[key] !== old[key]) {
            await this.$nextTick()
            this.$refs.catalogEl.scrollIntoView({ start: 'block', behavior: 'smooth' })
            return
          }
        }
      })
    }
    await this.$nextTick()
    useWindowHandlers().listen('resize', this.resizeHandler, true)
  },
  beforeDestroy () {
    useWindowHandlers().stopListening('resize', this.resizeHandler)
  },
  methods: {
    addAutoResize () {
      this.searchInputElement = (this.$refs.selectEl.$el.querySelector('input'))
      this.searchInputElement.addEventListener('input', this.searchAutoresizeHandler)
    },
    removeAutoResize () {
      this.searchInputElement?.removeEventListener('input', this.searchAutoresizeHandler)

      this.searchInputElement?.style.width = ''
    },
    searchAutoresizeHandler (ev?: InputEvent) {
      const el = this.searchInputElement as HTMLElement
      if (ev?.inputType.toLowerCase().includes('delete') || ev?.inputType.toLowerCase().includes('undo')) { el.style.width = '' }
      el.style.width = Math.min(Math.max(el.clientWidth, el.scrollWidth), this.autoResizeSearchMaxWidth) + 'px'
    },
    queryHandler,
    getLabel,
    isDefaultValue,
    sortQueryHandler (payload) {
      this.sortQuery = payload
      this.queryHandler({ sort_order: this.sortQuery.value || undefined }, this)
    },

    resizeHandler () {
      if (window.innerWidth < 768) {
        this.pageRange = 3
        this.removeAutoResize()
        return
      }
      this.pageRange = 7
    },
    removeFilter (key: CatalogKeys) {
      const query = {}
      query[key] = undefined
      this.queryHandler(query)
    },
    uncheckCheckbox (checkbox: FilterCheckbox) {
      const query = {}

      const tagsArray = this.$route.query.having_tags.split(',').map(Number)

      const filteredTagsArray = tagsArray.filter(tag => tag !== checkbox.id)

      if (filteredTagsArray.length > 0) {
        query.having_tags = filteredTagsArray.join(',')
      } else {
        query.having_tags = undefined
      }

      for (const filter in this.localCheckboxes) {
        const checks = this.localCheckboxes[filter].find(item => item === checkbox)

        if (checks) {
          checks.checked = false
        }
      }

      queryHandler(query, this)
    },

    applyFilters (payload: FilterObj, checkboxes: FilterObjCheckbox) {
      this.filtersModal = false

      const query: Record<string, string | number | Array<string | number> | undefined> = {}
      for (const key in payload) {
        if (isDefaultValue(key as CatalogKeys, payload[key].filters[0].value, this.maxPrice)) {
          query[key] = undefined
          continue
        }

        query[key] = payload[key].filters[0].value as string | number
      }

      const havingTags = []
      this.localCheckboxes = checkboxes

      for (const key in checkboxes) {
        const filters = checkboxes[key].filter(checkbox => checkbox.checked)

        if (filters.length > 0) {
          for (const filter of filters) {
            havingTags.push(filter.id)
          }
        }
      }

      if (havingTags.length > 0) {
        query.having_tags = havingTags.join(',')
      } else {
        query.having_tags = undefined
      }

      queryHandler(query, this)
    }
  }
})
